import { createStore } from 'vuex'
import layout from '@/store/modules/layout/index'
import expert from '@/store/modules/expert/index'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    layout,
    expert
  }
})
